import React from "react";

import Page from "../../components/Page";
import MessageList from "../../components/sections/message/MessageList";

const Messages = () => {
  const breadcrumb = [
    {
      path: "/",
      breadcrumbName: "Home",
    },
    {
      path: "",
      breadcrumbName: "Messages",
    },
  ];
  return (
    <>
      <Page title="Messages" breadcrumb={breadcrumb}>
        <div className="page-container">
          <MessageList />
        </div>
      </Page>
    </>
  );
};

export default Messages;
